module.exports = __webpack_public_path__ + "img/Success-2.b0febaf2.png";